import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';

import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class UserBlackListTableItem extends Component {
  render() {
    return (
      <tr>
        <td className="td-main">
          <NavLink to={`/users/profile/${this.props.item.blockedUserId}`}>
            <i className="fa fa-user" /> {this.props.blockedUser.username}
          </NavLink>
        </td>
        <td>
          {
            this.props.causes.find(item => item.id === this.props.item.causesId)
              .title
          }
        </td>
        <td>{this.props.item.comment}</td>
        <td>{formatter.dateFormat1(this.props.item.createdAt)}</td>
        <td className="text-warning text-right">
          <a
            href=""
            title="Удалить из списка"
            onClick={e => {
              e.preventDefault();
              this.props.openRemovePopUp(this.props.item.blockedUserId);
            }}
          >
            <i className="fa fa-trash text-danger" />
          </a>
        </td>
      </tr>
    );
  }
}

UserBlackListTableItem.propTypes = {
  // IN
  openRemovePopUp: PropTypes.func.isRequired,
  item: PropTypes.shape({
    category: PropTypes.number.isRequired,
    blockedUserId: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired,
    causesId: PropTypes.number.isRequired,
    comment: PropTypes.string.isRequired
  }).isRequired,

  // CONNECT
  blockedUser: PropTypes.shape({
    username: PropTypes.string.isRequired
  }).isRequired,
  causes: PropTypes.arrayOf(PropTypes.shape).isRequired
};

const mapStateToProps = (state, props) => ({
  blockedUser: selectItemById(
    state,
    'usersModule.collections.userCollection',
    props.item.blockedUserId
  ),
  causes: getItemFromRefList(state, 'userBlackListCauses')
});

export default withRouter(connect(mapStateToProps)(UserBlackListTableItem));



// WEBPACK FOOTER //
// ./src/components/UserBlackList/UserBlackListTable/common/UserBlackListTableItem.js